import React, {} from "react";
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import { makeStyles } from "@material-ui/core/styles";

const WWAdminBox = (props) => {
    const classes = useStyles();
    return (
        <Grid container >
            <Grid item xs={12} sx={{mt: 3, mx:1, my:1, background: 'linear-gradient(to right, #fcfcfc 0%,#f5f7ff 43%,#edf0ff 100%);', borderRadius: 5, boxShadow: '3px 5px 10px 1px #dddddd','@media (min-width: 1636px)': {mx: 3}}}>
                <List sx={{p:0, m:0}}>
                    <ListItem sx={{p: 0}} disablePadding 
                    // secondaryAction={ 
                    //     <IconButton sx={{mr:3}} disabled>
                    //         <img src={require('../../assets/teach.png')} width='140px' className={classes.image} />
                    //     </IconButton>
                    // }
                    >
                        <ListItemButton sx={{borderRadius: 4, p: 4}}>
                            <ListItemText 
                                sx={{m:0, px:0}} 
                                primary={<Typography variant="body2" sx={{ color: '#5f5600ff',fontWeight: '800', fontSize: '1.8rem','@media (min-width: 1636px)': {fontSize: '2.6rem'} }}>{props.totCount}</Typography>}
                                secondary={<Typography sx={{ color: '#5f5600ff', fontSize: '1rem',fontWeight: '500','@media (min-width: 1636px)': {fontSize: '1.4rem'} }}>{props.text}</Typography>}
                            />
                        </ListItemButton>
                    </ListItem>
                </List>
            </Grid>
        </Grid>
    )
}
const useStyles = makeStyles({
    image: {
      "@media (min-width: 1636px)": {
        width: "11rem",
      },
    },
  });
export default WWAdminBox;